export default __webpack_public_path__ + "static/media/step-two-frames.b3f2372b.jpg";